export default "__VITE_ASSET__DKe6BHK6__"